module.exports = __webpack_public_path__ + "static/media/et.dadf2a5c.svg";